export const environment = {
  production: false ,
  DocumentFolder: "\\\\cij-srv01\\Applicaties\\M-L-P\\FileShare-test",
  BijlagenFolder: "Bijlagen",
  CertificatenDir: "Certificaten",
  ApplicationName: "MLP TESTOMGEVING",
  exactUrl: "https://start.exactonline.nl/api/oauth2/auth?client_id=a49f2799-0d14-4011-8a1e-bf574107a8c4&redirect_uri=https://mlp-tst.cijborculo.nl/api/exact/token/AuthenticationCode&response_type=code&force_login=1",

};
